import { render } from "./AuthExpired.vue?vue&type=template&id=abf0b0b2&scoped=true"
import script from "./AuthExpired.vue?vue&type=script&lang=js"
export * from "./AuthExpired.vue?vue&type=script&lang=js"

import "./AuthExpired.vue?vue&type=style&index=0&id=abf0b0b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf0b0b2"]])

export default __exports__